<template>
    <div class="formpart range_input">
        <input type="range"
               :name="name"
               :min="min"
               :max="max"
               :step="step"
               :aria-valuemin="min"
               :aria-valuemax="max"
               :aria-valuenow="currentValue"
               v-model.number="currentValue">
        <output for="fader">
            <translate :translate-params="{myValue: currentValue, max: max}">
                %{myValue} von %{max}
            </translate>
        </output>
    </div>
</template>

<script>
export default {
    name: 'range-input',
    props: {
        name: {
            type: String,
            required: true
        },
        value: {
            required: false,
            default: 1
        },
        min: {
            type: Number,
            required: false,
            default: 1
        },
        max: {
            type: Number,
            required: false,
            default: 10
        },
        step: {
            type: Number,
            required: false,
            default: 1
        }
    },
    inheritAttrs: false,
    computed: {
        currentValue: {
            get() {
                const value = Number(this.value ?? this.min);

                if (value < this.min) {
                    return this.min;
                }

                if (value > this.max) {
                    return this.max;
                }

                return value;
            },
            set(value) {
                this.$emit('input', Number(value));
            }
        }
    }
}
</script>
